import {email, maxLength, minLength, required, requiredIf} from "vuelidate/lib/validators";
import identificationCodePolicy from "@/views/tourism/mixins/identificationCodePolicy";

//TODO need refactoring
export default {
  mixins: [identificationCodePolicy],
  data() {
    return {
      LetterMaskError: false,
    }
  },
  validations: {
    payer: {
      identificationCode: {
        // Для СК з правилом за віком (Guardian — від 16 років) ІПН
        // страхувальника обов'язковий незалежно від галочки «Відсутній ІПН».
        required: requiredIf(function (nestedModel) {
          return this.isInnRequiredByAge(this.payer.dateBirth) || !this.payer.withoutIdentificationCode;
        }), customMinLength(value) {
          if (this.payer.withoutIdentificationCode && !this.isInnRequiredByAge(this.payer.dateBirth)
            && (value === null || value === undefined || value === '')) {
            return true;
          }
          return value !== undefined && value !== null && value.length === 10;
        },
        // Дата народження зашита в перших 5 цифрах ІПН — розбіжність
        // блокує перехід на наступний крок.
        matchesBirthDate(value) {
          if (this.payer.withoutIdentificationCode && !this.isInnRequiredByAge(this.payer.dateBirth)) {
            return true;
          }
          if (!value || value.length !== 10 || !this.payer.dateBirth || this.payer.dateBirth.length !== 10) {
            return true;
          }
          return this.validateTaxNumber(value, this.payer.dateBirth);
        }
      },
      name: {
        required, minLength: minLength(2), maxLength: maxLength(30),
        onlyLatinCharacters(value) {
          return this.onlyLatinCharactersAndNum(value);
        }
      },
      surname: {
        required: requiredIf(function (nestedModel) {
          return true
        }), minLength: minLength(2), maxLength: maxLength(30),
        onlyLatinCharacters(value) {
          return this.onlyLatinCharacters(value);
        }
      },
      dateBirth: {
        required,
        // maxValue: moment().format('DD.MM.YYYY'),
        minLength: minLength(10),
        maxLength: maxLength(10),
        customMinLength(value) {
          return value !== null && value.length === 10;
        },
        daysInMonth: function (value) {
          if (value === null) {
            return true
          }

          return (parseInt(moment(value, 'DD.MM.YYYY').format('DD'))) <= moment(value, 'DD.MM.YYYY').daysInMonth();
        },
        isAdult(value) {
          if (!((parseInt(moment(value, 'DD.MM.YYYY').diff(moment(), 'years')) * -1) >= 18)) {
            this.errors['payer.errorBirthDate'] = ["Страхувальнику повинно бути більше 18 років"];

            return false;
          }

          return true
        }
      },
      phone: {required, minLength: minLength(19)},
      mail: {required, email},
      city: {required, minLength: minLength(1)},
      street: {
        required, customMinLength(value) {
          if (this.payer.street == null || this.payer.street == "") {
            return true;
          }
          return value !== null && value.length >= 4;
        }
      },
      house: {
        required, minLength: minLength(1), onlyLatinAndNumAndSpecials(value) {
          return this.onlyLatinAndNumAndSpecials(value);
        }
      },
      apartment: {
        minLength: minLength(1), onlyLatinAndNumAndSpecials(value) {
          return this.onlyLatinAndNumAndSpecials(value);
        }
      },
    },
  },
  methods: {
    getError(name) {
      if (this.hasError(name)) {
        return this.errors[name][0].replace(name, '');
      }
      return [];
    },
    onlyLatinCharactersAndNum(str) {
      if (str == undefined || str == null || str == "") return true;
      return /^[a-zA-Z0-9\- ]+$/.test(str);
    },
    LetterMask(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[A-Za-z\- ]+$/.test(char)) {
        this.LetterMaskError = false;
        return true;
      } // Match with regex
      else {
        this.LetterMaskError = true;
        e.preventDefault();
      }
    },
    validateTaxNumber(tax_number, date) {
      let tax_numberDate = moment('01.01.1900', 'DD.MM.YYYY').add(tax_number.substr(0, 5) - 1, 'day');
      let birthDate = moment(date, 'DD.MM.YYYY');

      return tax_numberDate.isSame(birthDate, 'year')
        && tax_numberDate.isSame(birthDate, 'month')
        && tax_numberDate.isSame(birthDate, 'day');
    },
    errorBirthDate: function () {
      if (this.payer.dateBirth == "" || this.payer.dateBirth == null || this.payer.dateBirth == "") {
        return false;
      }
      if ((parseInt(moment(this.payer.dateBirth, 'DD.MM.YYYY').diff(moment(), 'years')) * -1) < 18) {
        this.errors['payer.errorBirthDate'] = ["Страхувальнику повинно бути більше 18 років"];

        return true;
      } else if ((parseInt(moment(this.payer.dateBirth, 'DD.MM.YYYY').diff(moment(), 'years') - 1) * -1) > 100) {
        this.errors['payer.errorBirthDate'] = ["Страхувальнику повинно бути не більше 100 років"];

        return true;
      } else {
        delete this.errors['payer.errorBirthDate'];
      }
      return false;
    },
    hasError(name, index = false) {
      if (!index) {
        return this.errors[name] !== undefined;
      } else {
        if (!!this.errors[name]) {
          return this.errors[name][index] !== undefined;
        } else return false;
      }
    },
    onlyLatinCharacters(str) {
      if (str == null || str == "") return true;
      return /^[a-zA-Z\- ]+$/.test(str);
    },
    onlyLatinAndNumAndSpecials(str) {
      if (str == null || str == "") return true;

      if (/^[a-zA-Z0-9а-яґєіїА-ЯЄҐЇІ\-.\/ ]+$/.test(str)) {
        // additional check for any number
        return /\d/.test(str);
      }
      return false;
    },
    LetterNumSymbolsMask(e){
        let char = String.fromCharCode(e.keyCode); // Get the character
        if (/^[A-Za-z0-9а-яґєіїА-ЯЄҐЇІ\-.\/ ]+$/.test(char)) {
            this.LetterMaskError = false;
            return true;
        } // Match with regex
        else {
            this.LetterMaskError = true;
            e.preventDefault();
        }
    },
  },
}
